
import getLodop from '@/utils/LodopFuncs'
import { guid } from '../../utils/index'
import Outstock from '../../service/outstock'
import { Message } from 'element-ui'
import { sendMessage, getConnectStatus } from '../../utils/douyinPrinterPluins'
import LoadingService from '../../utils/loadingService'
// let LODOP
const sleep = (time) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve()
    }, time)
  })
}

// const baseParams = { 'method': 'logistics.getShopKey', 'param_json': '{}', 'v': '2' }
const getPrintData = (row) => {
  const { printer, documentID, templateURL, signature, encryptedData, options = {}} = row
  console.log(options)
  const requestID = guid()
  const taskID = guid()
  // const params = { ...options, ...baseParams }
  const paramsString = `access_token=${options['access_token']}&app_key=${options['app_key']}&method=logistics.getShopKey&param_json={}&timestamp=${options.timestamp}&v=2&sign=${options.sign}`

  // 'access_token=61c01f76-6fbe-4a7f-b813-16e6e4ae47a0&app_key=7397620382968628762&method=logistics.getShopKey&param_json={}&timestamp=1724982810&v=2&sign=ce7b1a1cd70ac3032d48bbb89ce93edc&sign_method=md5'

  // for (const key in param {
  //   if (Object.prototype.hasOwnProperty.call(params, key)) {
  //     paramsString += `${key}=${params[key]}&`
  //   }
  // }
  // paramsString = paramsString.slice(0, -1)
  return {
    'cmd': 'print',
    'requestID': requestID,
    'version': '1.0',
    'task': {
      'taskID': taskID,
      'preview': false,
      'printer': printer,
      'documents': [
        {
          'documentID': documentID,
          'contents': [
            { 'templateURL': templateURL, 'params': paramsString, 'signature': signature, 'encryptedData': encryptedData }
          ]
        }
      ]
    }
  }
}
export async function printTemplate(row, ruleForm) {
  // ctx.loading1 = false
  LoadingService.show('正在打印中...')
  try {
    const LODOP = getLodop()
    const { index, intOrient, pageSize, printer } = ruleForm
    // console.log(row, LODOP.Printers)
    // ctx.loading = true
    // debugger
    for (let idx = 0; idx < row.length; idx++) {
      const { printData, documentID, signature, templateURL, printingPlatform, salesOrderCode } = row[idx]
      if (printingPlatform === 4) { // 抖音打印
        try {
          const resp = await Outstock.calcapisign({ method: 'logistics.getShopKey', bizOrderId: salesOrderCode })
          const { result, message, appKey, sign, timestamp, accessToken = '61c01f76-6fbe-4a7f-b813-16e6e4ae47a0' } = resp.data
          if (result === 0) {
            const options = { 'access_token': accessToken, 'app_key': appKey, timestamp, sign }
            const printoptions = getPrintData({ printer, documentID, templateURL, signature, encryptedData: printData, options })
            console.log(printoptions)
            if (getConnectStatus()) {
              sendMessage(printoptions)
              await sleep(2000)
            }
          } else {
            Message.error(message)
          }
        } catch (error) {
          console.log(error)
          Message.error(error.message)
        }
      } else { // 普通打印
        LODOP.PRINT_INIT('')
        LODOP.SET_PRINT_MODE('PRINT_PAGE_PERCENT', 'Auto-Width')
        // LODOP.SET_PRINT_MODE('PRINT_PAGE_PERCENT', 'Full-Page')
        LODOP.SET_PRINTER_INDEX(index)
        LODOP.SET_PRINT_PAGESIZE(intOrient || 1, 0, 0, pageSize)
        // LODOP.ADD_PRINT_HTM(0, 0, '100%', '100%', item.printTemplate)
        LODOP.ADD_PRINT_HTM('0mm', '2mm', 'RightMargin:2mm', 'BottomMargin:0mm', printData)
        // LODOP.SELECT_PRINTER()
        // LODOP.SET_PREVIEW_WINDOW(2, 0, 0, 800, 600, '')
        // LODOP.PREVIEW()
        // LODOP.PRINT_SETUP()
        // LODOP.PRINT_DESIGN()
        LODOP.PRINT()
        await sleep(2000)
      }
    }
    LoadingService.hide()
    Message.success('打印结束')
    // ctx.loading = true
    // row.forEach((item, idx) => {
    //   setTimeout(() => {
    //     LODOP.PRINT_INIT('')
    //     LODOP.SET_PRINT_MODE('PRINT_PAGE_PERCENT', 'Auto-Width')
    //     // LODOP.SET_PRINT_MODE('PRINT_PAGE_PERCENT', 'Full-Page')
    //     LODOP.SET_PRINTER_INDEX(index)
    //     LODOP.SET_PRINT_PAGESIZE(intOrient || 1, 0, 0, pageSize)
    //     // LODOP.ADD_PRINT_HTM(0, 0, '100%', '100%', item.printTemplate)
    //     LODOP.ADD_PRINT_HTM('0mm', '2mm', 'RightMargin:2mm', 'BottomMargin:0mm', item.printTemplate)
    //     // LODOP.SELECT_PRINTER()
    //     // LODOP.SET_PREVIEW_WINDOW(2, 0, 0, 800, 600, '')
    //     // LODOP.PREVIEW()
    //     // LODOP.PRINT_SETUP()
    //     // LODOP.PRINT_DESIGN()
    //     LODOP.PRINT()
    //     console.log(idx)
    //     if (idx === row.length - 1) {
    //       ctx.loading = false
    //     }
    //   }, idx * 2000)
    // })
  } catch (error) {
    // ctx.loading = false
    LoadingService.hide()
    console.log(error)
    Message.error(error.message)
  }
}
// // eslint-disable-next-line no-unused-vars
// let TASK_LIST = []
// let tick = null
// const methods = {
//   'C_WaitFor'(jobId, index) {
//     TASK_LIST[index].time += 1
//     let TaskID1 = null
//     let TaskID2 = null
//     // eslint-disable-next-line camelcase
//     LODOP.On_Return_Remain = true
//     // eslint-disable-next-line camelcase
//     LODOP.On_Return = function(TaskID, Value) {
//       // console.log('TaskID1:', TaskID1, TaskID, Value)
//       console.log(TaskID1, TaskID2, TaskID, Value)
//       if (TaskID === TaskID1) {
//         if (Value === '1') {
//           TASK_LIST[index].done = true
//           TASK_LIST[index].message = '打印成功'
//           console.log(jobId, '打印成功')
//         }
//       } else if (TaskID === TaskID2) {
//         if (Value === '0') {
//           TASK_LIST[index].done = true
//           TASK_LIST[index].message = '打印任务被删除'
//           console.log(jobId, '打印任务被删除！')
//         }
//       }
//     }
//     TaskID1 = LODOP.GET_VALUE('PRINT_STATUS_OK', jobId)
//     TaskID2 = LODOP.GET_VALUE('PRINT_STATUS_EXIST', jobId)
//     // if (c > 50) {
//     //   clearTimeout(t)
//     //   document.getElementById('T12B').value = '打印超时(50秒)！'
//     //   c = 0
//     //   alert('打印超过50秒没捕获到成功状态！')
//     // }
//   },
//   'WaitFor'(jobId, index) {
//     TASK_LIST[index].time += 1
//     if (LODOP.GET_VALUE('PRINT_STATUS_OK', jobId)) {
//       TASK_LIST[index].done = true
//       TASK_LIST[index].message = '打印成功'
//       console.log(jobId, '打印成功')
//     }
//     if ((!LODOP.GET_VALUE('PRINT_STATUS_EXIST', jobId))) {
//       TASK_LIST[index].done = true
//       TASK_LIST[index].message = '打印任务被删除'
//       console.log(jobId, '打印任务被删除！')
//     }
//     // else if (TASK_LIST[index].time > 30) {
//     //   document.getElementById('T12B').value = '打印超时(30秒)！'
//     //   alert('打印超过30秒没捕获到成功状态！')
//     // }
//   }
// }
// const waitFor = (list = TASK_LIST) => {
//   console.log(list)
//   const listNew = list.filter(i => !i.done)
//   if (listNew.length === 0) {
//     clearInterval(tick)
//     // eslint-disable-next-line no-const-assign
//     TASK_LIST = []
//     return
//   }
//   listNew.forEach((item, index) => {
//     methods[item.method](item.jobId, index)
//   })
//   tick = setTimeout(() => {
//     waitFor()
//   }, 1000)
// }

// export function getTaskList() {
//   return TASK_LIST
// }
// export function printTemplateNew(row, ruleForm) {
//   console.log(row)
//   const length = row.length
//   let count = 0
//   try {
//     LODOP = getLodop()
//     row.forEach((item) => {
//       LODOP.PRINT_INIT('')
//       LODOP.SET_PRINT_MODE('PRINT_PAGE_PERCENT', 'Auto-Width')
//       LODOP.SET_PRINT_MODE('CATCH_PRINT_STATUS', true)
//       LODOP.SET_PRINTER_INDEX(ruleForm.index)
//       LODOP.SET_PRINT_PAGESIZE(ruleForm.intOrient || 1, 0, 0, ruleForm.pageSize)
//       LODOP.ADD_PRINT_HTM('0mm', '2mm', 'RightMargin:2mm', 'BottomMargin:0mm', item.printTemplate)
//       if (LODOP.CVERSION) {
//         // eslint-disable-next-line camelcase
//         LODOP.On_Return_Remain = true
//         // eslint-disable-next-line camelcase
//         LODOP.On_Return = function(TaskID, value) {
//           // console.log(TaskID, value)
//           if (value) {
//             TASK_LIST.push({
//               jobId: value,
//               method: 'C_WaitFor',
//               done: false,
//               time: 0,
//               message: '未打印'
//             })
//             // console.log(TASK_LIST)
//             count++
//             if (length === count) {
//               waitFor()
//             }
//           }
//         }
//         LODOP.PRINT()
//       } else {
//         const jobId = LODOP.PRINT()
//         if (jobId) {
//           TASK_LIST.push({
//             jobId,
//             method: 'WaitFor',
//             done: false,
//             time: 0,
//             message: '未打印'
//           })
//           count++
//           if (length === count) {
//             waitFor()
//           }
//         }
//       }
//     })
//   } catch (error) {
//     console.log(error)
//   }
// }
